import { defineComponent, useModel, computed, openBlock, createBlock, unref } from 'vue';
import { ElSlider } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                               */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "effect-filter",
  props: {
    "modelValue": { default: "1" },
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const model = useModel(__props, "modelValue");
    const sliderModel = computed({
      get() {
        return Number(model.value) || 1;
      },
      set(newValue) {
        model.value = newValue.toString();
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ElSlider), {
        height: "6.25rem",
        vertical: "",
        modelValue: sliderModel.value,
        "onUpdate:modelValue": ($event) => sliderModel.value = $event,
        min: 1,
        max: 24e3
      }, null, 8, ["modelValue", "onUpdate:modelValue"]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=effect-filter.vue.js.map
